import { useEffect, useRef, useState } from "react"
import { CallStateSnapshot, SipPhoneManager } from "../../core/SipPhoneManager"
import Div from "../base/Div"
import FlexRow from "../base/FlexRow"
import Icon from "../base/Icon"
import Timer from "../timer/Timer"
import { closeBrowserPhone, createJob, openJobQuickView } from "../../core/Global"
import Job from "../../modules/crm/jobs/models/Job"
import Indicator from "../base/Indicator"
import { useCallJobSource } from "./useCallJobSource"




interface IProps {
    call: CallStateSnapshot
    phone: SipPhoneManager
    isTech: boolean
    callerId?: string
    jobs: Job[]
}
export default function ActiveCallCompact(props: IProps) {

    const [transfering, transferingSet] = useState<boolean>(false)
    const jobSource = useCallJobSource(props.call)

    const ref = useRef<HTMLDivElement>(null);

    const [dragging, setDragging] = useState(false);
    const [offset, setOffset] = useState({ x: 0, y: 0 });

    const onMouseDown = (e: React.MouseEvent) => {
        if (!ref.current) return;

        setDragging(true);

        const rect = ref.current.getBoundingClientRect();

        setOffset({
            x: e.clientX - rect.left,
            y: e.clientY - rect.top,
        });
    };

    useEffect(() => {
        const onMove = (e: MouseEvent) => {
            if (!dragging || !ref.current) return;

            ref.current.style.left = `${e.clientX - offset.x}px`;
            ref.current.style.top = `${e.clientY - offset.y}px`;

            ref.current.style.right = "auto";
            ref.current.style.bottom = "auto";
        };

        const onUp = () => setDragging(false);

        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseup", onUp);

        return () => {
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("mouseup", onUp);
        };
    }, [dragging, offset]);


    const [established, establishedSet] = useState<boolean>(false)

    useEffect(() => {
        if (props.call.status == "established" && !established)
            establishedSet(true)
    }, [props.call.status])

    useEffect(() => {
        if (props.call.status == "held") {
            props.phone.unholdCall(props.call.id)
        }
    }, [props.call.id])

    return (
        <div ref={ref} className="float-compact-active-call bg-light"
            onClick={async e => {
                e.preventDefault()
                await props.phone.unlockAudio()
            }}
            onMouseDown={onMouseDown}>

            <FlexRow column justify="between">

                <FlexRow className="fs-7">
                    {
                        props.call.status == "established" ?
                            <Timer baseDate={props.call.startedAt} />
                            : props.call.status == "ringing" ?
                                <>
                                    Ringing...
                                </>
                                : props.call.status == "establishing" ?
                                    <>
                                        Connecting...
                                    </>
                                    : props.call.status == "held" ?
                                        <>
                                            <Icon icon="pause-circle" type="solid" className="me-1" />
                                            <span>Hold</span>
                                        </>
                                        :
                                        <>Calling...</>
                    }
                </FlexRow>

                {
                    props.callerId ?
                        <div className="fs-3">
                            {
                                props.isTech && <Icon icon="user-helmet-safety" className="me-1" />
                            }
                            {props.callerId}
                        </div>
                        :
                        <div className="fs-2">
                            {props.call.callerId}
                        </div>
                }

                {
                    jobSource.jobSourceName &&
                    <FlexRow className="fs-8 text-gray-700 mt-1">
                        <Icon icon="bullhorn" type="solid" className="me-1" />
                        {jobSource.jobSourceName}
                    </FlexRow>
                }

                {
                    props.phone.getState().calls
                        .filter(c => c.id != props.call.id && c.status != "ended")
                        .map(c => (
                            <FlexRow key={`active-call-other-call-${c.id}`} className="w-100 border-bottom py-3"
                                onClick={async e => {
                                    e?.preventDefault()
                                }}>

                                <div className="fs-8">
                                    {c.callerId}
                                </div>
                                {
                                    c.status == "ringing" ?
                                        <FlexRow className="ms-auto">

                                            <Div title="Reject" className="me-5"
                                                onClick={async () => {
                                                    await props.phone.hangup(c.id)
                                                }}>
                                                <Icon icon="circle-phone-hangup" type="solid" className="text-danger" size={26} />
                                            </Div>

                                            <Div title="Answer"
                                                onClick={async () => {
                                                    await props.phone.holdCurrentAndAnswer(c.lineId, c.id)
                                                }}>
                                                <Icon icon="circle-phone" type="solid" className="text-success" size={26} />
                                            </Div>

                                        </FlexRow>
                                        : c.status == "establishing" ?
                                            <div className="fs-8 ms-auto">
                                                <Indicator text="connecting..." />
                                            </div>
                                            :
                                            <FlexRow className="fs-8 ms-auto">
                                                <a className="fs-8" href="#"
                                                    onClick={async (e) => {
                                                        e.preventDefault()
                                                        await props.phone.holdCall(props.call.id)
                                                        await props.phone.unholdCall(c.id)
                                                    }}>
                                                    <Icon icon="phone-arrow-down-left" className="me-1" />
                                                    Switch
                                                </a>
                                            </FlexRow>
                                }

                            </FlexRow>
                        ))
                }

                {
                    props.jobs.length > 0 &&
                    <div className="scroll-y" style={{ maxHeight: 200 }}>
                        {
                            props.jobs.map(job =>
                                <FlexRow key={`active-call-job-${job.id}`} className="w-100 border-bottom py-3"
                                    onClick={e => {
                                        e?.preventDefault()
                                        openJobQuickView(job.id)
                                    }}>

                                    <div className="me-10">
                                        <div className="fs-7 mt-1">
                                            #{job.jobId}
                                        </div>
                                        <FlexRow>
                                            <Icon icon="wrench" className="me-1 text-gray-800 fs-8" />
                                            <span className="text-gray-800 fs-8">
                                                {job.jobType}
                                            </span>
                                        </FlexRow>
                                        <FlexRow>
                                            <Icon icon="circle" type="solid" color={job.jobStatus?.color} size={12} />
                                            <span className="fs-8 ms-1 limited-text" style={{ width: 80 }}>
                                                {job.jobStatus?.name}
                                            </span>
                                        </FlexRow>
                                    </div>

                                    <div className="ms-auto me-2">
                                        <a href="#" onClick={e => e.preventDefault()}>
                                            <Icon icon="chevron-circle-right" type="solid" doutone size={24} />
                                        </a>
                                    </div>

                                </FlexRow>
                            )
                        }
                    </div>
                }

                {
                    props.call.direction == "incoming" && props.call.status == "ringing" ?
                        <FlexRow className="w-100" justify="center">
                            <Div className="dialpad-number" title="Reject"
                                onClick={async () => {
                                    await props.phone.hangup(props.call.id)
                                }}>
                                <Icon icon="circle-phone-hangup" type="solid" className="text-danger" size={35} />
                            </Div>
                            <Div className="dialpad-number">
                            </Div>
                            <Div className="dialpad-number" title="Answer"
                                onClick={async () => {
                                    await props.phone.answerCall(props.call.id)
                                }}>
                                <Icon icon="circle-phone" type="solid" className="text-success" size={35} />
                            </Div>
                        </FlexRow>
                        :
                        <FlexRow className="w-100" justify="center">
                            <Div className="dialpad-number pb-0"
                                onClick={async () => {
                                    if (!established) return;
                                    transferingSet(t => !t)
                                }}>
                                <Icon icon="circle-arrow-right" type="solid" className={`${!established ? "text-gray-400" : transfering ? "text-primary" : "text-gray-600"}`} size={30} />
                            </Div>
                            <Div className="dialpad-number pb-0" title="Hold"
                                onClick={async () => {
                                    if (!established) return;
                                    if (props.call.isHeld)
                                        await props.phone.unholdCall(props.call.id)
                                    else
                                        await props.phone.holdCall(props.call.id)
                                }}>
                                <Icon icon={`${(props.call.isHeld ? "play-circle" : "pause-circle")}`} type="solid" className={`${!established ? "text-gray-400" : props.call.isHeld ? "text-primary" : "text-gray-600"}`} size={30} />
                            </Div>
                            <Div className="dialpad-number pb-0" title="End Call"
                                onClick={async () => {
                                    await props.phone.hangup(props.call.id)
                                }}>
                                <Icon icon="circle-phone-hangup" type="solid" className="text-danger" size={30} />
                            </Div>
                            <Div className="dialpad-number pb-0" title={props.call.isMuted ? "Unmute" : "Mute"}
                                onClick={async () => {
                                    if (props.call.isMuted)
                                        await props.phone.unmuteCall(props.call.id)
                                    else
                                        await props.phone.muteCall(props.call.id)
                                }}>
                                <Icon icon="microphone-circle" type="solid" className={`${props.call.isMuted ? "text-danger" : "text-gray-600"}`} size={30} />
                            </Div>
                            <Div className="dialpad-number pb-0"
                                onClick={() => {
                                    closeBrowserPhone()
                                    createJob(undefined, undefined, {
                                        phone: props.call.callerId,
                                        jobSourceId: jobSource.jobSourceId
                                    })
                                }}>
                                <Icon icon="circle-plus" type="solid" className="text-gray-600" size={30} />
                            </Div>
                        </FlexRow>
                }

            </FlexRow>
        </div>
    )
}